import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('star-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.625 35.612l-10.821 4.205a.645.645 0 0 1-.878-.638l.655-11.59-7.343-8.993a.645.645 0 0 1 .335-1.032L17.8 14.605l6.283-9.762a.645.645 0 0 1 1.086 0l6.283 9.762 11.226 2.96a.645.645 0 0 1 .335 1.031l-7.343 8.992.655 11.591a.645.645 0 0 1-.878.638l-10.821-4.205z",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }));
});